const middleware = {}

middleware['auth-ssr'] = require('../middleware/auth-ssr.js')
middleware['auth-ssr'] = middleware['auth-ssr'].default || middleware['auth-ssr']

middleware['authenticated'] = require('../middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

export default middleware
